export default "__VITE_ASSET__24310172__"